import {locationContainer, RenderingServices} from '@wallaby-ui/core';

export default function baseEncounterDocumentLinkStatefullFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {store, routeParams} = services;
  const {data, queryParameters} = params;
  const rowData = data;
  const ownQueryParameters = store
    ? store.getState()[locationContainer.LOCATION_REDUCER_STATE_ID].parameters
    : queryParameters;
  const searchParams = {
    ...ownQueryParameters[locationContainer.GLOBAL_PARAMETERS_PATH],
  };

  const encounterId = routeParams?.encounterId;
  const documentId = rowData.documentVersionId;

  return {...params, rowData, searchParams, encounterId, documentId};
}
